export enum LVED_LINKS {
  termsOfService = 'http://www.lved.com/terms',
  pricacyPolicy = 'http://www.lved.com/privacy',
}
